<template lang="html">
  <div>
    <b-row>
      <b-col sm="12">
        <b-card style="height:770px;">
          <b-row>
            <b-col sm="4" style="height:700px;">
              <b-row class="pl-3">
                <b-col sm="12" class="pb-4">
                  <span class="card-title wise-card-title">1Depth</span>
                </b-col>
                <b-col sm="12" style="overflow-y:scroll;height:650px;">
                  <b-table
                    outlined
                    selectable
                    :select-mode="'single'"
                    selectedVariant="secondary"
                    :fields="depth1Fields"
                    :items="depth1Items"
                    @row-selected="rowSelected"
                  >
                  <template slot="item_code" slot-scope="row">
                    <div>{{row.item.item_code}}</div>
                  </template>
                  <template slot="item_name" slot-scope="row">
                    <b-form-input v-on:keyup.enter="updateGroupName(row.item)" v-model="row.item.item_name" placeholder="Enter code name"></b-form-input>
                  </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="4">
              <b-row class="pl-3">
                <b-col sm="12" class="pb-4">
                  <span class="card-title wise-card-title">2Depth</span>
                </b-col>
                <b-col sm="12" style="overflow-y:scroll;height:650px;">
                  <b-table
                    outlined
                    selectable
                    :select-mode="'single'"
                    selectedVariant="secondary"
                    :fields="depth2Fields"
                    :items="depth2Items"
                    @row-selected="depth2_selected"
                  >
                  <template slot="item_code" slot-scope="row">
                    <div>{{row.item.item_code}}</div>
                  </template>
                  <template slot="item_name" slot-scope="row">
                    <b-form-input v-on:keyup.enter="updateGroupName(row.item)" v-model="row.item.item_name" placeholder="Enter code name"></b-form-input>
                  </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="4">
              <b-row class="pl-3">
                <b-col sm="12" class="pb-4">
                  <span class="card-title wise-card-title">3Depth</span>
                </b-col>
                <b-col sm="12" style="overflow-y:scroll;height:650px;">
                  <b-table
                    outlined
                    selectable
                    :select-mode="'single'"
                    selectedVariant="secondary"
                    :fields="depth3Fields"
                    :items="depth3Items"
                  >
                  <template slot="item_code" slot-scope="row">
                    <div>{{row.item.item_code}}</div>
                  </template>
                  <template slot="item_name" slot-scope="row">
                    <b-form-input v-on:keyup.enter="updateGroupName(row.item)" v-model="row.item.item_name" placeholder="Enter code name"></b-form-input>
                  </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import swal from 'sweetalert2'
const moment = require("moment");
import cSwitch from '../../components/Switch';

export default {
  components: {
    cSwitch,
  },
  data() {
    return {
      depth1Fields: [{'item_code': {'label': '메뉴코드',}}, {'item_name': {'label': '메뉴명',}}], // 코드 뎁스1 테이블 필드
      depth1Items: [], // 코드 뎁스1 테이블 데이터
      depth2Fields: [{'item_code': {'label': '메뉴코드',}}, {'item_name': {'label': '메뉴명',}}], // 코드 뎁스2 테이블 필드
      depth2Items: [], // 코드 뎁스2 테이블 데이터
      depth3Fields: [{'item_code': {'label': '메뉴코드',}}, {'item_name': {'label': '메뉴명',}}], // 코드 뎁스3 테이블 필드
      depth3Items: [], // 코드 뎁스3 테이블 데이터
    }
  },
  watch: {
  },
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    // 1Depth (ROOT)코드 리스트 조회
    this.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=MENU')
    .then((result) => {
      this.depth1Items = result.data;
    })
  },
  methods: {
    // 메소드명 : selectItemUnitList(parentCode, depth)
    // ### 코드리스트 조회 ###
    // parentCode를 기준으로 코드리스트를 조회
    //
    // 최초작성 : 2016.05.23
    // 파라미터 :
    //  - parentCode(부모 아이템 코드)
    //  - depth(조회되는 코드리스트가 몇번째 뎁스의 코드리스트인지에 대한 정보)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.23  이승훈   최초작성
    // *************************
    selectItemUnitList(parentCode, depth){
      var depthXItems = [];
      var token = sessionStorage.getItem("myToken");
      this.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=' + parentCode)
      .then((result) => {
        depthXItems = result.data;
        switch (depth) { // 몇번째 뎁스에 해당하는 코드리스트인지 파악
          case 2:
            this.depth2Items = this.$_.clone(depthXItems);
            break;
          case 3:
            this.depth3Items = this.$_.clone(depthXItems);
            break;
          case 4:
            this.depth4Items = this.$_.clone(depthXItems);
            break;
          default:
        }
      })
    },
    // 1뎁스에서 특정 코드가 선택 됬을때 2뎁스의 하위 코드리스트 조회
    rowSelected(items) {
      this.depth2Items = []; // 초기화
      this.depth3Items = []; // 초기화
      this.depth4Items = []; // 초기화
      this.selectItemUnitList(items[0].item_code, 2);
    },
    // 2뎁스에서 특정 코드가 선택 됬을때 3뎁스의 하위 코드리스트 조회
    depth2_selected(items){
      this.depth3Items = []; // 초기화
      this.depth4Items = []; // 초기화
      this.selectItemUnitList(items[0].item_code, 3);
    },
    // 메소드명 : updateGroupName(unit)
    // ### 코드명 업데이트 ###
    // 해당 코드의 이름을 변경
    //
    // 최초작성 : 2016.05.23
    // 파라미터 :
    //  - unit(JSON 형태의 코드 아이템 데이터)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.23  이승훈   최초작성
    // *************************
    updateGroupName(unit){
      if(unit.saved != false){
        swal.fire({
          title: '코드 변경!',
          text: "선택하신 코드를 변경하시겠습니까?",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'OK'
        }).then((swalResult) => {
          if (swalResult.value) {
            var token = sessionStorage.getItem("myToken");
            unit.edit_id = this.$session.get('userId');
            unit.edit_date = moment().format('YYYY-MM-DD HH:mm:ss');

            var param = encodeURI(JSON.stringify(unit));
            var data = new FormData();
            data.append('unitObj', param);

            this.$http.post('/api/update/itemCode?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '코드를 변경하였습니다.',
                  showConfirmButton: false,
                  timer: 1500
                })
            })
          }
        })
      }
    },
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/views/common/MenuManagement.vue